import { gql } from '@/__generated__';

const GET_UPDATE_DEVICE_FIELDS = gql(`#graphql
  query DeviceConfiguration_GetUpdateDeviceFields($deviceId: ID!, $deviceIdString: String!) {
    device(input: { id: $deviceId }) {
      id
      shares
      profile {
        id
        name
        alias
        originalName
        type: type2
        organization {
          id
          name
        }
        location {
          latitude
          longitude
        }
      }
    }
    # AMARU-851: set completo de colecciones ICN/CUSTOM ya asignadas al device (any org,
    # aunque en la práctica siempre debería coincidir con su organización) — reemplaza al
    # singular deprecado icnCollection. El form filtra client-side a ICN/CUSTOM (DGA y
    # ORGANIZATION quedan fuera del alcance de este campo).
    deviceCollections: collections(filter: { deviceId: $deviceIdString }) {
      id
      name
      type
    }
  }
`);

export default GET_UPDATE_DEVICE_FIELDS;
